import { motion } from 'framer-motion';

export default function Card({
  children,
  className = '',
  hover = false,
  variant = 'default',
  padding = 'md',
  ...props
}) {
  const baseStyles = 'rounded-2xl transition-all duration-300';

  const variants = {
    default: 'bg-secondary-800 shadow-md border border-secondary-700',
    outline: 'bg-secondary-900 border-2 border-secondary-700',
    filled: 'bg-secondary-900',
    gradient: 'bg-gradient-to-br from-primary-900/20 to-primary-800/20',
  };

  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const hoverStyles = hover ? 'hover:shadow-xl hover:-translate-y-1 cursor-pointer' : '';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`${baseStyles} ${variants[variant]} ${paddings[padding]} ${hoverStyles} ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
}
